import { ArrowUpRight } from "lucide-react";
import { useAds } from "@/lib/hooks";
import { useAuth } from "@/store/AuthContext";

export default function AdSlot({ variant = "banner", ...rest }) {
  const { user } = useAuth();
  const { data } = useAds(variant);
  if (user?.is_premium) return null;
  const ad = (data && data[0]) || null;
  const testId = rest["data-testid"] || `ad-slot-${variant}`;

  if (!ad) return null;

  if (variant === "banner") {
    return (
      <aside
        data-testid={testId}
        className="w-full rounded-2xl border border-dashed border-stone-300 bg-paperAlt px-6 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
      >
        <div className="flex items-start md:items-center gap-4">
          <span className="tag-pill" data-testid="ad-label">{ad.label}</span>
          <div>
            <p className="font-serif text-xl text-stone-900 leading-tight">{ad.title}</p>
            <p className="text-sm text-stone-600 mt-1">{ad.body}</p>
          </div>
        </div>
        <button
          className="btn-outline whitespace-nowrap self-start md:self-auto"
          data-testid="ad-cta-banner"
        >
          {ad.cta} <ArrowUpRight size={16} />
        </button>
      </aside>
    );
  }

  return (
    <aside
      data-testid={testId}
      className="rounded-2xl border border-dashed border-stone-300 bg-sand/40 p-6 flex flex-col gap-3"
    >
      <div className="flex items-center justify-between">
        <span className="tag-pill">{ad.label}</span>
        <span className="eyebrow">{ad.brand}</span>
      </div>
      <p className="font-serif text-2xl text-stone-900 leading-snug">{ad.title}</p>
      <p className="text-sm text-stone-700">{ad.body}</p>
      <button className="btn-primary self-start" data-testid="ad-cta-inline">
        {ad.cta} <ArrowUpRight size={16} />
      </button>
    </aside>
  );
}
